import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";

interface PricePerSqFtModalProps {
    details?: SeasonDates;
    year: number;
    show: boolean;
    toggle: () => void;
}

interface SeasonDates {
    startDate: string;
    endDate: string;
    maximumWorkAmountPerDay: number;
    webPriceAdjustmentAmount: number;
}


const SeasonDatesModal: React.FC<PricePerSqFtModalProps> = ({details, year, show, toggle}) => {
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);
    const [maxAmountDaily, setMaxAmountDaily] = useState<number>(0);
    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        const postData = {
            scheduleStartDate: startDate,
            scheduleEndDate: endDate,
            maximumWorkAmountPerDay: maxAmountDaily,
            webPriceAdjustmentAmount: details.webPriceAdjustmentAmount
        }
        businessYearService.updateSeasonalInfo(postData, year).then(r => {
            eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_SEASON_DATES)
            eventEmitter.emit(EventEmitterTypes.REFRESH_YEARLY_SETTINGS)
            toggle();
        })
    }
    useEffect(() => {
        if(details){
            setStartDate(details.startDate);
            setEndDate(details.endDate);
            setMaxAmountDaily(details.maximumWorkAmountPerDay)
        } else {
            setStartDate(null);
            setEndDate(null);
        }
        
    }, [details]);

    
    
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Season Date</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="date" className="col-md-6 mb-3">
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                placeholder="Select a date"
                            />
                        </Form.Group>
                        <Form.Group controlId="date" className="col-md-6 mb-3">
                            <Form.Label>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                placeholder="Select a date"
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SeasonDatesModal;
